import React, {useContext, createContext, useEffect, useCallback} from "react";
import useTheme, {IUseTheme} from "./use-theme";
import useSidebar , {IUseSidebar} from "./use-sidebar";

interface IProps {
    children : React.ReactNode
}

type IContext = {
    theme : IUseTheme,
    sidebar : IUseSidebar
}

export const Context = createContext({} as IContext);

export function Provider ({children} : IProps) {
    const theme = useTheme();
    const sidebar = useSidebar();

    const {changeColor : _changeColor,getLangByCode :_getLangByCode} = theme;
    const handlerStorage = useCallback(()=>{
        const _theme = localStorage.getItem('theme');
        if (_theme === "dark" || _theme === "default") {
            _changeColor(_theme)
        }
        const lang = localStorage.getItem('lang');
        if (lang === "en-US" || lang === "fa-IR") {
            _getLangByCode(lang)
        }
    },[_changeColor,_getLangByCode])
    useEffect(()=>{
        window.addEventListener('storage', handlerStorage);
        return ()=>{
            window.removeEventListener('storage', handlerStorage);
        }
    },[handlerStorage])

    return <Context.Provider value={{
        theme,
        sidebar
    }}>{!theme.loading ? children : ''}</Context.Provider>;
}

export const useMain = () => {
    return useContext(Context);
};

